module.exports = __webpack_public_path__ + "img/brand.885d48d7.svg";